import { render, staticRenderFns } from "./eod-user-detail.vue?vue&type=template&id=6db1db5f"
import script from "./eod-user-detail.vue?vue&type=script&lang=js"
export * from "./eod-user-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports